import { useRequiredContext } from "@redotech/react-util/context";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { useQuery } from "@tanstack/react-query";

const CUSTOM_ANALYTICS_REPORT_QUERY_KEY = "customAnalyticsReport";

export function getCustomAnalyticsReportQueryKey(
  teamId: string,
  customReportId: string,
) {
  return [CUSTOM_ANALYTICS_REPORT_QUERY_KEY, teamId, customReportId] as const;
}

export function getCustomAnalyticsReportQueryInvalidationKey(teamId: string) {
  return [CUSTOM_ANALYTICS_REPORT_QUERY_KEY, teamId] as const;
}

export function useCustomAnalyticsReportQuery({
  customReportId,
}: {
  customReportId: string;
}) {
  const team = useRequiredContext(TeamContext);
  const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);

  return useQuery({
    queryKey: getCustomAnalyticsReportQueryKey(team._id, customReportId),
    queryFn: async () => {
      return await rpcClient.getCustomAnalyticsReport({ id: customReportId });
    },
    refetchInterval: (query) => {
      if (query.state.data?.status === "preparing") {
        return 2000;
      }
      if (query.state.data?.status === "ready") {
        return 10 * 1000;
      }
      return false;
    },
    staleTime: 10 * 1000,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });
}
